<template>
  <dimmed v-if="isShow">
    <div class="history__wrap">
      <i class="icon icon--close-btn" @click="onClose"></i>
      <span class="title">{{ $t('group.column.history') }}</span>
      <div class="info">{{ collectionPayload.url }}</div>
      <div v-if="listData.length !== 0" class="timezone">{{ timezone  }}</div>
      <div class="list">
        <template v-if="listData.length !== 0">
          <div class="thead">
            <table>
              <colgroup>
                <col style="width: 100px;">
                <col style="width: 360px;">
              </colgroup>
              <thead>
                <tr>
                  <th v-for="column in columns"
                    :key="`tag-list-${column.text}-${column.value}`"
                    :class="[{ active: listData.length && computedSort === column.value }]"
                    @click="changeSort(column.value)">
                    {{ column.text }}
                    <button class="sort"
                          :class="{ active: listData.length && computedSort === column.value,
                                    asc: order,
                                    desc: !order }">
                      <i class="icon icon--sort-asc"></i>
                      <i class="icon icon--sort-desc"></i>
                    </button>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="tbody">
            <table>
               <colgroup>
                <col style="width: 100px;">
                <col style="width: 360px;">
              </colgroup>
              <tbody>
                <template v-for="(item, idx) in realList[listOption.pageNum - 1]">
                  <tr :key="idx">
                    <td>{{ item.date }}</td>
                    <td>{{ item.pv }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="list-bottom" v-if="listData">
            <ui-navigation class="page-navigation"
                           :currentPage="listOption.pageNum"
                           :disabled="lastPage === 1"
                           :lastPage="lastPage"
                           @setPage="setPage" />
          </div>
        </template>
        <template v-else>
          <div class="wrap">
            <div class="no-data">
              <span>{{ $t('group.collection.noData') }}</span>
            </div>
          </div>
        </template>
      </div>
    </div>
  </dimmed>
</template>
<script>
import UiNavigation from '@/components/ui/UiNavigation'
import { getHeatmapDailyPvList } from '@/api/group'
import { mapState } from 'vuex'
import { format } from 'date-fns'
import { EventBus } from '@/libs/event-bus'
import Dimmed from '@/components/ui/Dimmed.vue'

export default {
  components: {
    Dimmed,
    UiNavigation
  },
  props: [
    'isHistoryView',
    'collectionPayload'
  ],
  data () {
    return {
      listData: [],
      listOption: {
        pageNum: 1,
        itemsPerPage: 30,
        sort: '-date'
      },
      lastPage: 0,
      timezone: null,
      isLoadedOnce: false,
      wholePage: 0,
      isShow: false
    }
  },
  computed: {
    ...mapState([
      'domain'
    ]),
    columns () {
      return [
        {
          text: this.$t('common.date'),
          value: 'date'
        },
        {
          text: this.$t('common.collectedPv'),
          value: 'pv'
        }
      ]
    },
    order () {
      return !this.listOption.sort.includes('-')
    },
    computedSort () {
      return this.listOption.sort.replace('-', '')
    },
    realList () {
      const slice = []
      for (let i = 0; i < this.listData.length; i += this.listOption.itemsPerPage) {
        slice.push(this.listData.slice(i, i + this.listOption.itemsPerPage))
      }
      return slice
    }
  },
  methods: {
    onClose () {
      this.$emit('isHistoryView', false)
    },
    setPage (page) {
      this.listOption.pageNum = page
    },
    loadHeatmapDailyPvList () {
      EventBus.$emit('onLoading', true)
      const today = format(new Date(), 'YYYY-MM-DD')
      const endDate = this.collectionPayload.endDate ? format(this.collectionPayload.endDate, 'YYYY-MM-DD') : null
      const payload = {
        aid: this.collectionPayload.aid,
        parentSid: this.collectionPayload.parentSid,
        startDate: this.collectionPayload.startDate,
        endDate: endDate < today ? endDate : today
      }
      getHeatmapDailyPvList(payload, true).then(result => {
        let arr = []
        for (let i = 0; i < result.list.length; i++) {
          arr.push({
            date: result.list[i][0],
            pv: result.list[i][1]
          })
        }
        this.wholePage = arr.length
        this.listData = arr
        this.timezone = '(' + this.domain.timezone + ')' + this.domain.timezoneName
        if (!this.isLoadedOnce) {
          this.sortInList()
          this.isLoadedOnce = true
        }
        this.calcLastPage()
        this.isShow = true
        EventBus.$emit('onLoading', false)
      })
    },
    changeSort (sort) {
      if (this.listOption.sort === '-' + sort) {
        this.listOption.pageNum = 1
        this.listOption.sort = sort
      } else {
        this.listOption.pageNum = 1
        this.listOption.sort = '-' + sort
      }
      this.sortInList()
    },
    calcLastPage () {
      this.lastPage = Math.ceil(this.wholePage / this.listOption.itemsPerPage)
    },
    sortInList () {
      this.listData.sort((a, b) => {
        if (typeof a[this.computedSort] === 'string' && typeof b[this.computedSort] === 'string') {
          if (this.order) {
            return a[this.computedSort].toString().localeCompare(b[this.computedSort].toString())
          } else {
            return b[this.computedSort].toString().localeCompare(a[this.computedSort].toString())
          }
        } else {
          if (this.order) {
            return a[this.computedSort] > b[this.computedSort] ? 1 : -1
          } else {
            return b[this.computedSort] > a[this.computedSort] ? 1 : -1
          }
        }
      })
    }
  },
  created () {
    this.loadHeatmapDailyPvList()
  }
}
</script>
<style lang="scss" scoped>
.history__wrap {
  width: 530px;
  border-radius: 14px;
  background-color: #fff;
  position: relative;
  padding: 30px 30px 25px 30px;
  .icon--close-btn {
    position: absolute;
    right: 15px;
    top: 15px;
  }
  .title {
    color: #444;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
  }
  .info {
    color: #2F2F2F;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    height: 16px;
    padding: 12px 0 24px 0;
  }
  .timezone {
    color: #666;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    height: 16px;
    padding-bottom: 12px;
  }

  .list {
    position: relative;
    height: 295px;
    table {
      position: relative;
      width: 100%;
    }
    .tbody {
      height: 210px;
      overflow-x: hidden;
      overflow-y: scroll;
    }
    thead {
      tr {
        border-radius: 7px;
        th {
          height: 20px;
          font-size: 13px;
          font-weight: normal;
          background: #555;
          color: #ffffff;
          padding: 12px 0;
          text-align: center;
          white-space: nowrap;
          vertical-align: bottom;
          .icon {
            vertical-align: middle;
            margin: -1px 5px 1px 0;
            cursor: pointer;
          }

          &.gap {
            padding: 0;
            width: 25px;
            border-bottom: none;
          }

          .sort {
            display: inline-block;
            width: 14px;
            height: 18px;
            padding: 1px 0;
            margin-top: -2px;
            margin-left: 2px;
            vertical-align: middle;
            border-radius: 4px;
            transition: background-color 0.15s ease,
              box-shadow 0.15s ease;

            i.icon {
              float: left;
              opacity: 0.2;
              transition: opacity 0.15s ease;
            }

            &.active {
              &.asc {
                .icon--sort-asc {
                  opacity: 1;
                }
              }

              &.desc {
                .icon--sort-desc {
                  opacity: 1;
                }
              }
            }

            &.active {
              background-color: #272727;
              box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.146);
            }
          }

          &.hover {
            .sort {
              background-color: #272727;
              box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.146);
            }
          }

          &:first-child {
            border-radius: 7px 0 0 7px;
          }

          &:last-child {
            border-radius: 0 7px 7px 0;
          }
        }
      }
    }
    tbody {
      tr {
        position: relative;
        height: 1px;

        td {
          height: 100%;
          text-align: center;
          font-size: 13px;
          line-height: 1.31;
          letter-spacing: normal;
          color: #666;
          word-break: break-all;
          border-bottom: 1px solid #ebebeb;
          vertical-align: top;
          padding: 12px 0;

          .td-data {
            position: relative;
            height: 100%;
            padding: 17px 15px 17px 15px;
            box-sizing: border-box;

            &.checkbox {
              padding-left: 34px;
            }

            .ui_checkbox {
              position: absolute;
              top: 15.5px;
              left: 8px;
              margin-left: 2px;
              margin-right: 1px;
            }
          }

          &.gap {
            width: 25px;
            border-bottom: none;
          }

          &.td-regDate {
            text-align: right;

            .td-data {
              margin-right: 20px;
              padding-right: 6px;
            }
          }
          .history {
            height: 34px;
            display: flex;
            padding: 9px 18px;
            justify-content: center;
            align-items: center;
            border: 1px solid #4A8500;
            color: #4A8500;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            border-radius: 61px;
          }
        }
      }
    }
    .list-bottom {
      text-align: center;
      z-index: 2;
      position: absolute;
      width: 100%;
      bottom: -4px;
      margin: 0 -10px 0 0;
      height: 49px;
      border-top: 1px solid rgba(0, 0, 0, 0.16);

      .view-per-page {
        float: right;
        font-size: 12px;
        color: #767676;
        padding: 0px 26px 0 0;
        margin-top: -5px;

        .ui_select {
          padding-left: 5px;
        }
      }
    }
    .wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      position: relative;
      .no-data {
        color: #666;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        position: absolute;
        top: 40%;
      }
    }
  }
}
</style>
